import { render, staticRenderFns } from "./CaseStatus.vue?vue&type=template&id=733f2757"
import script from "./CaseStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseStatus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports